import styled from 'styled-components';

export const CustomFooterStyle = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 453px;
  margin: 0 auto;
`;

export const CFButton = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const CFButtonChop = styled.div`
  display: flex;
  justify-content: flex-end;
  background: white;
  border-top: 1px solid #dedede;
  margin: 0 auto;
  width: 100%;

  @media all and (max-width: 600px) {
    width: 100%;
  }
  @media all and (max-width: 350px) {
    left: 15px;
    width: 100%;
  }
`;
